import apiConfig from "@/configs/api-config";
import apiUtil from "@/utils/api-util";

// 列表
var list = (params, successCallback, failCallback) => {
    apiUtil.config(apiConfig.article.list).request({
        params: params
    }).then(result => {
        if(result.error_code == apiConfig.errorCode.success) {
            successCallback(result.data);
        } else {
            failCallback(result.error_code, result.errorMsg);
        }
    });
}
var detail = (id, successCallback, failCallback) => {
    apiUtil.config(apiConfig.article.detail, {
        id: id
    }).request().then(result => {
        if(result.error_code == apiConfig.errorCode.success) {
            successCallback(result.data);
        } else {
            failCallback(result.error_code, result.errorMsg);
        }
    });
}
export default {
    list,
    detail
}



// WEBPACK FOOTER //
// ./src/models/article-model.js